module.exports = __webpack_public_path__ + "assets/img/22_268_big.ce9a0de5.jpg";